import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { URLS, Url } from '@wix/da-url';
import { ModalType } from '../../../Modals/redux/types';
import Button from '../../../Button';
import { withVerification, } from '../../../VerificationPopup/withVerification';
import s from './BurgerMenu.scss';
var SubmitMenu = /** @class */ (function (_super) {
    tslib_1.__extends(SubmitMenu, _super);
    function SubmitMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitMenuItems = [
            {
                key: 'siteHeader.deviation',
                url: URLS.SUBMIT,
                verificationAction: 'submit',
            },
            tslib_1.__assign({ key: 'siteHeader.statusUpdate', verificationAction: 'submitstatus' }, _this.getItemProps(ModalType.STATUS_UPDATE)),
            tslib_1.__assign({ key: 'siteHeader.poll', verificationAction: 'submitpoll' }, _this.getItemProps(ModalType.POLL_EDIT)),
        ];
        return _this;
    }
    SubmitMenu.prototype.getItemProps = function (type) {
        var _a;
        if (this.props.redirectOnSubmit) {
            var types = (_a = {},
                _a[ModalType.STATUS_UPDATE] = 'status',
                _a[ModalType.POLL_EDIT] = 'poll',
                _a);
            return {
                url: Url.browseHomeLink() + "?submit_modal=" + types[type],
            };
        }
        return { onClick: this.openModal(type) };
    };
    SubmitMenu.prototype.openModal = function (type, options) {
        var _this = this;
        return function () {
            _this.props.pushModal(type, tslib_1.__assign({ wrapInPopup: false }, options));
        };
    };
    SubmitMenu.prototype.render = function () {
        var _a = this.props, t = _a.t, isOpen = _a.isOpen, onToggle = _a.onToggle, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup;
        return (React.createElement("div", { className: s['submit-menu-block'] },
            React.createElement("div", { className: classnames(s['submit-menu-shade'], isOpen && s['is-active']), onClick: onToggle }),
            React.createElement("div", { className: classnames(s['submit-menu-wrapper'], isOpen && s['is-opened']) },
                React.createElement(Button, { className: s['submit-button'], onClick: onToggle },
                    t('siteHeader.submit'),
                    ' ',
                    React.createElement("span", { className: s['plus-minus-icon'] }, isOpen ? '−' : '+')),
                React.createElement("ul", { className: s['submit-menu'] }, this.submitMenuItems.map(function (_a) {
                    var url = _a.url, key = _a.key, onClick = _a.onClick, verificationAction = _a.verificationAction;
                    return (React.createElement("li", { key: key },
                        React.createElement("a", { href: !isVerificationNeeded && url
                                ? url
                                : 'javascript:void(0)' // eslint-disable-line no-script-url
                            , onClick: !isVerificationNeeded
                                ? onClick
                                : function () { return pushVerificationPopup(verificationAction); }, className: classnames(s['list-item']) }, t(key))));
                })))));
    };
    return SubmitMenu;
}(React.Component));
export { SubmitMenu };
export default withVerification(withTranslation()(SubmitMenu));
//# sourceMappingURL=SubmitMenu.js.map